import { Button, IconCode } from '@screentone/core';

import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
import { useContextMenuActions } from 'contexts/context-menu-actions/useContextMenuActions';
import { ModuleContainer } from 'data/generated/graphql';
import { AddAllessehCollectionModal } from './AddAllessehCollectionModal';

interface AddAllessehCollectionProps {
  hierarchyId: string;
  module: ModuleContainer;
  maxAllowedItems: number;
  viewOnly?: boolean;
}

export const AddAllessehCollection = ({
  hierarchyId,
  module,
  maxAllowedItems,
  viewOnly = false
}: AddAllessehCollectionProps) => {
  const { setActionModalComponent, setIsModalOpen } = useContextMenuActions();

  const handleAddCollectionId = () => {
    setIsModalOpen(true);

    setActionModalComponent(
      <AddAllessehCollectionModal
        hierarchyId={hierarchyId}
        module={module}
        maxAllowedItems={maxAllowedItems}
        viewOnly={viewOnly}
      />
    );
  };

  return (
    <ReadOnlyTooltip disabled={viewOnly}>
      <Button
        tertiary
        icon={IconCode}
        onClick={handleAddCollectionId}
        disabled={viewOnly}
        data-testid="page-draft-add-collection-id"
      >
        Add collection ID
      </Button>
    </ReadOnlyTooltip>
  );
};
